export const translations = {
  limpar: {
    pt: 'Limpar',
    en: 'To clean',
    de: 'Zum Reinigen',
    es: 'Para Limpiar',
  },
  filtrar: {
    pt: 'Filtrar',
    en: 'Filter',
    de: 'Filter',
    es: 'Filtrar',
  },
  exportFile: {
    pt: 'Exportar Excel',
    en: 'Export Excel',
    de: 'Excel Exportieren',
    es: 'Exportar Excel',
  },
  client: {
    pt: 'Cliente',
    en: 'Customer',
    de: 'Kunde',
    es: 'Cliente',
  },
  product: {
    pt: 'Produto',
    en: 'Product',
    de: 'Produkt',
    es: 'Producto',
  },
  type: {
    pt: 'Tipo',
    en: 'Type',
    de: 'Typ',
    es: 'Tipo',
  },
  expirationDate: {
    pt: 'Data de Validade',
    en: 'Expiration Date',
    de: 'Verfallsdatum',
    es: 'Fecha de Expiración',
  },
  lastUpdate: {
    pt: 'Última Atualização',
    en: 'Last Update',
    de: 'Letzte Aktualisierung',
    es: 'Última Actualización',
  }
};
